import React from "react";
import styles from "./Tracktor.module.scss";
import Select from "react-select";
import mars from "./tracktor.png";
import {connect} from "react-redux";
import idea from "./idea.svg";


class Tracktor extends React.Component{
    state = {
        name:null,
        batteryColor:null,
        selectedIndex:-1,
        filter:80
    }
    onBatteryFilter = (info)=>{
        this.setState({
            filter:info.value
        })
    }
    render(){
        const directions = [
            { value: "all", label: "all" },
        ]
        const disable = this.state.name && this.state.batteryColor
        const zones = []
        const plots = []
        const cropsland = []
        this.props.zones.forEach((e,zindex)=>{
            zones.push({value:e.name,label:e.name,index:zindex})
            e.plots.forEach((p,pindex)=>{
                plots.push({value:p.name,label:p.name,parent:zindex})
                p.cropsland.forEach((c,cindex)=>{
                    cropsland.push({value:c.name,label:c.name,parent:pindex})
                })
            })
        })
        const battery = [
            { value: 0, label: "0%" },
            { value: 10, label: "10%" },
            { value: 20, label: "20%" },
            { value: 30, label: "30%" },
            { value: 40, label: "40%" },
            { value: 50, label: "50%" },
            { value: 60, label: "60%" },
            { value: 70, label: "70%" },
            { value: 80, label: "80%" },
            { value: 90, label: "90%" },
            { value: 100, label: "100%"},

        ]
        const curvedStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                width:"100%",
                height: 35,
                minHeight: 35,
                fontSize:"12px"
               
            })

        }
        
     
         
        const curvedStylesecond = {
            control: (base, state) => ({
                ...base,
                borderRadius: "25px",
                borderColor: "#ebedf0",
                width:"100%",
                height: 35,
                minHeight: 35,
                fontSize:"12px"
                
            })

        }
        const tracktors = [
                    {
                    name:"Mars 0003",
                    batteryColor:"#00BB61",
                    status:"Available Now",
                    remainingCharge:"4h 25min",
                    lastActivity:"05/08/20, 7:36PM",
                    color:"#00BB61",
                    percentage:80
                    },
                    {
                    name:"Mars 5571",
                    batteryColor:"#69BB00",
                    status:"Scheduled",
                    remainingCharge:"3h 5min",
                    lastActivity:"05/11/20, 10:12AM",color:"#FDB808",
                    percentage:80
                    },
                    {
                        name:"Mars 5581",
                        batteryColor:"#69BB00",
                        status:"Scheduled",
                        remainingCharge:"3h 5min",
                        lastActivity:"05/11/20, 10:12AM",color:"#FDB808",
                        percentage:50
                    },
                    {
                        name:"Mars 5582",
                        batteryColor:"#69BB00",
                        status:"Scheduled",
                        remainingCharge:"3h 5min",
                        lastActivity:"05/11/20, 10:12AM",color:"#FDB808",
                        percentage:50
                    },
                    {
                        name:"Mars 5587",
                        batteryColor:"#69BB00",
                        status:"Scheduled",
                        remainingCharge:"3h 5min",
                        lastActivity:"05/11/20, 10:12AM",color:"#FDB808",
                        percentage:20
                    },
                    {
                        name:"Mars 5586",
                        batteryColor:"#69BB00",
                        status:"Scheduled",
                        remainingCharge:"3h 5min",
                        lastActivity:"05/11/20, 10:12AM",color:"#FDB808",
                        percentage:10
                    },
                    {
                    name:"Mars 1318",
                    batteryColor:"#FDB808",
                    status:"Available Now",
                    remainingCharge:"1h 24min",
                    lastActivity:"05/11/20, 9:45AM",color:"#00BB61",
                    percentage:80
                    },
                    {
                    name:"Mars 0081",
                    batteryColor:"#00BB61",
                    status:"Working Now",
                    remainingCharge:"36min",
                    lastActivity:"05/08/20, 7:36PM",color:"#FDB808",
                    percentage:80
                    },
                    {
                    name:"Mars 0255",
                    batteryColor:"#FF2936",
                    status:"Available Now",
                    remainingCharge:"5min",
                    lastActivity:"05/08/20, 7:36PM",color:"#00BB61",
                    percentage:80
                    },
                    {
                    name:"Mars 0004",
                    batteryColor:"#CED2DA",
                    status:"Turned Off",
                    remainingCharge:"0min",
                    lastActivity:"05/08/20, 7:36PM",color:"#FF2936",
                    percentage:80
                    },
        ]
        const toRender = tracktors.filter((e)=>e.percentage === this.state.filter).map((e,i)=>{
           const hoverClasses = ["d-flex flex-column  p-3 tracktor__hover",styles.tracktor__hover] 
           return (
            <div onClick={()=>{
                this.setState({
                    name:e.name,
                    batteryColor:e.batteryColor,
                    selectedIndex:i
                    
                })
                
            }}  style={{
                border: "1px solid #EBEDF0",
                borderRadius: "15px",
                
            }} id="highlight" className={`${hoverClasses.join(" ")} ${this.state.selectedIndex === i?styles.tracktor__border:null}`} role="button">
                 <div id="outter" className="d-flex justify-content-between">
                     <p  id="inner"  style={{
                         fontWeight:"500",
                         fontSize:"18px",
                         flexBasis:"60%",
                         color: this.state.selectedIndex === i?"#3E7AFF":"#081C48"
                     }}>{e.name}</p>
                     <div style={{
                          flexBasis:"15%",
                     }}  className="d-flex align-items-center">
                         <small  style={{
                             color:e.batteryColor,
                         }}>{e.percentage}%</small>
                         <div className="d-flex ml-1">
                             <div style={{
                                 height:"15px",
                                 width:"6px",
                                 background:e.batteryColor
                             }} className="rounded"></div>
                             <div style={{
                                 height:"15px",
                                 width:"6px",
                                 marginLeft:"2px",
                                 background:e.batteryColor
                             }} className="rounded"></div>
                             <div style={{
                                 height:"15px",
                                 width:"6px",
                                 marginLeft:"2px",
                                 background:e.batteryColor
                             }} className="rounded"></div>
                             <div style={{
                                 height:"15px",
                                 width:"6px",
                                 marginLeft:"2px",
                                 background:e.batteryColor
                             }} className="rounded"></div>
                             <div style={{
                                 height:"15px",
                                 width:"6px",
                                 marginLeft:"2px",
                                 background: e.batteryColor,
                                 opacity: "0.3"
                             }} className="rounded"></div>
                         </div>
                     </div>
                 </div>
                 <div>
                     <div className="d-flex justify-content-between">
                         <p style={{
                             fontSize:"12px",
                             fontWeight:"400",
                             color:"#8690A5",
                             flexBasis:"60%",
                         }} >Status</p>
                         <p style={{
                             color:e.color,
                             flexBasis:"40%",
                             fontWeight:"500",
                             fontSize:"12px",
                           
                         }}>{e.status}  {i === 1?<img style={{
                             marginLeft:"8px"
                         }} src={idea} alt="idea"></img>:null }</p>
                     </div>
                     <div className="d-flex justify-content-between">
                         <p style={{
                            fontSize:"12px",
                            fontWeight:"400",
                            color:"#8690A5",
                            flexBasis:"60%",
                         }} className="text-muted">Remaining Charge</p>
                         <p style={{
                              color:"#081C48",
                              fontWeight:"500",
                              fontSize:"12px",
                              flexBasis:"40%"
                              
                         }}>{e.remainingCharge}</p>
                     </div>
                     <div className="d-flex justify-content-between">
                         <p style={{
                              fontSize:"12px",
                              fontWeight:"400",
                              color:"#8690A5",
                              flexBasis:"60%",
                         }} >Last Activity</p>
                         <p style={{
                              color:"#081C48",
                              fontWeight:"500",
                              fontSize:"12px",
                              flexBasis:"40%"
                              
                         }}>05/08/20, 7:36PM</p>
                     </div>
                     <img width="100%"  src={mars} alt="trackter"></img>
                 </div>
            </div>
           )
        })
        return <div className={styles.absolute_modal}>
                <div style={{
                cursor: "pointer",
                fontSize:"15px"
                }} onClick={() => {
                    this.props.toggleTracktor()
                }} className="d-flex text-muted tractkor-back-btn">
                <p><i class="fa fa-chevron-left"></i> </p>
                <p className={styles.back_button_text}>Back</p>
                </div>

                <div className="d-flex  align-items-center  p-2" style={{
                        width:"calc(100% - 100px)",
                        maxWidth:"100%",
                        marginLeft:"auto",
                        marginRight:"auto",
                        marginTop:"20px"
                    }}>
                    <h4>Z-Tractors<span style={{
                        color:"#CED2DA",
                        flexBasis:"20%"
                    }} className="ml-1">6</span></h4>
                    <div style={{
                         flexBasis:"80%"
                    }}  className="d-flex ml-2">
                       <div style={{
                           width:"20%",
                       }} className="d-flex align-items-center">
                           <small style={{
                               marginRight:"9px"
                           }} className="text-muted ml-1">Zone</small>
                           <Select className="ml-1 w-100 h-100" components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle} defaultValue={zones[0]} options={zones} ></Select>
                       </div>
                       <div style={{
                           width:"25%"
                       }} className="d-flex align-items-center">
                           <small style={{
                               marginRight:"9px"
                           }} className="text-muted ml-2">Plot</small>
                           <Select className="ml-1 w-100 " components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle} defaultValue={plots[0]} options={plots} ></Select>
                       </div>
                       <div style={{
                           width:"25%"
                       }} className="d-flex align-items-center">
                           <small style={{
                               marginRight:"9px"
                           }} className="text-muted ml-2">Cropland</small>
                           <Select className="ml-1 w-100" components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle} defaultValue={cropsland[0]} options={cropsland} ></Select>
                       </div>
                       <div style={{
                           width:"20%"
                       }} className="d-flex align-items-center">
                           <small style={{
                               marginRight:"9px"
                           }} className="text-muted ml-3">Status</small>
                           <Select className="ml-1 w-100" components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStyle} defaultValue={directions[0]} options={directions} ></Select>
                       </div>
                       <div style={{
                           width:"30%"
                       }} className="d-flex align-items-center">
                          <small style={{
                               marginRight:"9px"
                           }} className="text-muted ml-3">Sortby</small>
                          <Select  onChange={this.onBatteryFilter}  className="ml-1 w-100" components={{
                        IndicatorSeparator: () => null
                    }} styles={curvedStylesecond } defaultValue={battery[8]}   options={battery} ></Select>
                       </div>
                    </div>
                </div>
                <div className={styles.grid}>
                  {toRender}   
                </div>
                <div style={{
                    backgroundColor:"rgba(255,255,255,1)",
                    position:"fixed",
                    bottom:"0px",
                    width:"100%",
                    marginLeft:"-32px",
                    backdropFilter:"blur(25px)",
                    zIndex:"9999"
                }}>
                    <button onClick={()=>{
                        if(this.state.name && this.state.batteryColor){
                            this.props.selectTracktor(this.state.name,this.state.batteryColor)
                        }
                    }} style={{
                        width:"139px",
                        marginTop:"20px",
                        marginBottom:"18px",
                        marginRight:"20px",
                        height:"40px",
                        border:"none",
                        backgroundColor:disable?"#3E7AFF":"#EBEDF0",
                        borderRadius:"45px",
                        color:"#FFFFFF",
                        fontSize:"16px",
                        float:"right"
                    }}>
                        Submit
                    </button>
                </div>

        </div>
        
    }
}
const mapStateToProps = state =>{
    return {
        zones:state.zones
    }
}

export default connect(mapStateToProps,null)(Tracktor)